// extracted by mini-css-extract-plugin
module.exports = {"bordered_result":"orv-vergelijker-modal-data-grid_bordered_result__eHsss"};